import React from 'react';
import { formatFileSize } from './utils';

const ImageAttachment = ({ attachment }) => (
  <img
    src={attachment.url}
    alt={attachment.name || 'вложение'}
    loading="lazy"
    className="max-w-full rounded-xl max-h-80 object-contain"
  />
);

const VideoAttachment = ({ attachment }) => (
  <video src={attachment.url} controls className="max-w-full rounded-xl max-h-80">
    Ваш браузер не поддерживает воспроизведение видео.
  </video>
);

const FileAttachment = ({ attachment }) => (
  <a
    href={attachment.url}
    target="_blank"
    rel="noopener noreferrer"
    className="inline-flex items-center gap-2 text-sm text-orange-600 hover:text-orange-700 underline break-all">
    📎 {attachment.name || 'файл'}
    {attachment.size ? ` (${formatFileSize(attachment.size)})` : ''}
  </a>
);

const ATTACHMENT_RENDERERS = {
  image: ImageAttachment,
  video: VideoAttachment,
  file: FileAttachment,
};

const ChatAttachments = ({ attachments = [] }) => {
  if (!attachments.length) return null;

  return (
    <div className="mt-2 space-y-2">
      {attachments.map((attachment, index) => {
        const Renderer = ATTACHMENT_RENDERERS[attachment.kind] || FileAttachment;
        const key = `${attachment.kind || 'file'}-${attachment.name || 'attachment'}-${index}`;
        return <Renderer key={key} attachment={attachment} />;
      })}
    </div>
  );
};

export default ChatAttachments;
